<template>
  <div class="container">
    <set-box v-for="(set, id) in sortedSets" :set="set" :key="id" @click.native="openSet(set.id)"></set-box>
    <!--<set-box :set="all"></set-box>-->
  </div>
</template>

<script>
import setBox from "@/components/set-box.vue";
export default {
  name: "sets",
  created: function() {},
  data() {
    return {
      all: {
        name: "All Missing Pieces",
        set_img_url: "/static/randomlego.jpg"
      }
    };
  },
  props: {
    sets: Object,
    sort: String,
    search: String
  },
  components: {
    setBox
  },
  computed: {
    sortedSets() {
      console.log("Set Compute");
      if (this.sort); // Make sort a reactive dependency
      return Object.keys(this.sets)
        .map(id => {
          let filter = !(
            this.search == null ||
            [this.sets[id].name, this.sets[id].year].some(
              x =>
                String(x)
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) !== -1
            )
          );
          return { id, ...this.sets[id], filter };
        })
        .filter(set => !set.archive)
        .sort((a, b) => {
          return a.filter == b.filter ? a.sort - b.sort : a.filter - b.filter;
        });
    }
  },
  watch: {
    sort(n, o) {
      // Sort on sort change
      if (n) this.sortSets();
    },
    sets(n, o) {
      // Sort if sets change
      if (o == null) this.sortSets();
    }
  },
  methods: {
    sortSets() {
      let sets = Object.values(this.sets);
      switch (this.sort) {
        case "default":
          break;
        case "name":
          sets.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
          break;
        case "year":
          sets.sort((a, b) => {
            return a.year - b.year;
          });
          break;
        case "theme":
          sets.sort((a, b) => {
            return b.theme_id - a.theme_id;
          });
          break;
        case "parts":
          sets.sort((a, b) => {
            return b.num_parts - a.num_parts;
          });
          break;
        case "missing":
          sets.sort((a, b) => {
            return a.remaining - b.remaining;
          });
          break;
        case "completeness":
          sets.sort((a, b) => {
            return b.completeness - a.completeness;
          });
          break;
        case "incompleteness":
          sets.sort((a, b) => {
            return a.completeness - b.completeness;
          });
          break;
      }
      // Apply Sort values
      sets.forEach((set, i) => {
        set.sort = i;
      });
    },
    openSet: function(set) {
      this.$parent.menuBlur();
      this.$parent.search_input = null;
      this.$router.push("/sets/" + set);
      window.scrollTo(0, 0);
    } /*,
    openAllSets: function() {
      this.$parent.menuBlur();
      this.parts = {};
      this.settitle = "All Missing Parts";
      for (var set in this.sets) {
        for (var part in this.sets[set].parts) {
          this.parts.$add(set + "-" + part, this.sets[set].parts[part]);
        }
      }
      resort(this.parts);
      window.scrollTo(0, 0);
    }*/
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
}
</style>



// WEBPACK FOOTER //
// src/components/sets.vue